import React from "react";
import "./styles.scss";
import { getUser } from "../../helpers/user";

type TOption = { value: string; children: string };

interface ISelectProps {
  options: Array<any>;
  size: string;
  name?: string;
  label?: string;
  disabled?: boolean;
  error?: string;
  value?: string;
  show?: boolean;
  onChange?: (ev: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select = (props: ISelectProps) => {
  const shouldShow = props.show !== undefined ? props.show : true;
  const user = getUser();

  const nivelUsuario = user?.usuario?.nivel ? Number(user.usuario.nivel) : 0;

  const opcoesFiltradas = React.useMemo(() => {
    if (!props.options || !Array.isArray(props.options)) return [];

    if (nivelUsuario >= 9) return props.options;

    return props.options.filter((item: TOption) => {
      const textoOpcao = (item.children || "").toLowerCase();

      return (
        !textoOpcao.includes("ambiente validação") &&
        !textoOpcao.includes("ambiente validacao")
      );
    });
  }, [props.options, nivelUsuario]);

  return (
    <div className="select-wrapper" data-show={shouldShow}>
      <label className={`label label--${props.size}`}>{props.label}</label>
      <select
        className={`select select-${props.size}`}
        title={""}
        disabled={props.disabled}
        onChange={props.onChange}
        name={props.name}
        value={props.value || ""}
      >
        {opcoesFiltradas.map((item: TOption) => (
          <option key={item.value} value={item.value || ""}>
            {item.children}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
